<template>
    <div class="optpl-template-item optpl-template-item__template" :class="{ 'scrollable': this.shouldScroll, 'loaded': this.imageWasLoaded, 'faded': ! userHasTiers(template.tier_ids) }">
        <span :class="'optpl-template-item__mark optpl-template-item__tag optpl-template-item__tag-' + template.mark" v-if="template.mark">{{ template.mark.toUpperCase() }}</span>
        <span class="opui-spinner opui-spinner-border opui-text-gray-400 opui-mr-2" v-if="! this.imageWasLoaded"></span>

        <div class="optpl-template-item__image-container" @click="(template.type === 'customer_template' && showDetails) ? this.$router.push({ name: 'customer-template', params: { uid: template.uid } }) : this.$router.push({ name: 'template', params: { uid: template.uid } })">
            <figure
                :style="'background-image: url(' + (image ? image : this.imgUrl('img-placeholder.webp')) + ')'"
                class="optpl-figure"
                :class="this.figureId"
            >
                <img :src="image ? image : this.imgUrl('img-placeholder.webp')" alt="" @load="imageLoaded" />
            </figure>
        </div>

        <div class="optpl-template-item__text">
            <h4 class="opui-text-black">
                <span>{{ template.title ? template.title : 'Some Title' }}</span>
                <span class="optpl-template-item__price" v-if="template.price ">$199</span>
            </h4>

            <div class="optpl-template-item__tags" v-if="template.collections">
                <span class="optpl-template-item__tag optpl-template-item__tag-collection" v-for="collection in template.collections">{{ collection.title }}</span>
            </div>
            <div class="optpl-template-item__description">{{ template.description_text ? template.description_text : template.description }}</div>

            <div class="optpl-template-item__overlay optpl-template-item__overlay-template">
                <div class="optpl-template-item__overlay-top">
                    <router-link :to="{ name: 'customer-template', params: { uid: template.uid }}" class="opui-btn opui-btn-outline optpl-view-tpl-btn" v-if="template.type === 'customer_template' && showDetails">
                        {{ $e('Details') }}
                    </router-link>

                    <router-link :to="{ name: 'template', params: { uid: template.uid }}" class="opui-btn opui-btn-outline optpl-view-tpl-btn" v-else-if="showDetails">
                        {{ $e('Details') }}
                    </router-link>

                    <a :href="template.preview_link" class="opui-btn opui-btn-outline" v-if="template.preview_link" target="_blank">Preview</a>
                </div>

                <div class="optpl-template-item__overlay-bottom">
                    <UpgradeButton v-if="! userHasTiers(template.tier_ids) || showUpgrade" />
                    <a href="#" v-else-if="! purchaseLink" @click.prevent="createPage" class="opui-btn opui-btn-secondary optpl-view-tpl-btn">Use Template</a>

                    <a :href="purchaseLink"
                       class="opui-btn opui-btn-primary"
                       v-if="purchaseLink && purchaseText"
                       target="_blank"
                    >{{ purchaseText }}</a>
                </div>
            </div>
        </div>

        <a href="#" @click.prevent="toggleLike" class="optpl-template-like" :class="{ 'liked': template.liked }"><i class="opui-fa opui-fa-heart"></i></a>
    </div>
</template>

<script>
import CreateNewPageModal from "../../components/Templates/Modals/CreateNewPageModal.vue"
import UpgradeButton from "./UpgradeButton.vue"
import { useTemplatesStore } from "../../store/templates"
import { mapStores } from 'pinia'

export default {
    components: { CreateNewPageModal, UpgradeButton },
    props: {
        template:     { type: Object, required: true },
        showUpgrade:  { type: Boolean, default: false },
        showDetails:  { type: Boolean, default: true },
        purchaseLink: { type: String, default: '' },
        purchaseText: { type: String, default: '' },
    },
    data() {
        return {
            imageContainerHeight: 0,
            imageHeight: 0,
            scrollSpeed: '2s',
            shouldScroll: false,
            figureId: 'optpl-figure-' + this.template.uid,
            imageSrc:    '',
            imageWasLoaded: false,
        }
    },
    computed: {
        ...mapStores(useTemplatesStore),
        image() {
            this.imageSrc = ''

            if (this.template.preview)      this.imageSrc = this.template.preview
            if (this.template.preview_full) this.imageSrc = this.template.preview_full

            // If we still have no imageSrc, use a placeholder
            if (! this.imageSrc) this.imageSrc = this.imgUrl('img-placeholder.webp')

            return this.imageSrc
        },
    },
    methods: {
        createPage() {
            if (this.template && this.template.uid) {
                this.$vfm.show({ component: CreateNewPageModal, bind: { template: this.template } })
            } else {
                alert('Template not found: ' + this.templateUid)
            }
        },

        imageLoaded() {
            this.imageWasLoaded = true
            this.calculateAnimationSpeed()
        },

        calculateAnimationSpeed() {
            let $containers = document.getElementsByClassName('optpl-figure');
            let $elements   = document.getElementsByClassName('optpl-figure-' + this.template.uid);

            if ($elements && $elements.length) {
                this.imageHeight          = $elements[0].getElementsByTagName('img')[0].offsetHeight || $elements[0].getElementsByTagName('img')[0].height;
                this.imageContainerHeight = $elements[0].offsetHeight;
                this.shouldScroll         = this.imageHeight > this.imageContainerHeight;

                // Fallback height
                if (! this.imageContainerHeight) {
                    this.imageContainerHeight = $containers[0].offsetHeight;
                }

                // Last fallback
                if (! this.imageContainerHeight) {
                    this.imageContainerHeight = 250;
                }

                let pxPerSec  = 200;
                let distance  = this.imageHeight - this.imageContainerHeight;
                let speed     = (distance / pxPerSec) * 1000;

                // Fallback speed
                if (speed <= 0) {
                    speed = 1200;
                }

                this.scrollSpeed = Math.round(speed) + 'ms';
            }
        },

        toggleLike() {
            if (this.template.liked) {
                this.template.liked = false
                this.templatesStore.unlikeTemplate(this.template.uid)
            } else {
                this.template.liked = true
                this.templatesStore.likeTemplate(this.template.uid)
            }
        },
    }
}
</script>

<style scoped>
.optpl-template-item figure {
    background-repeat: no-repeat;
    background-size: contain !important;
    transition: background-position v-bind('scrollSpeed') ease-out;

    &:hover {
        background-position: 0 0 !important;
    }
}

.optpl-template-item.scrollable figure {
    background-size: cover !important;

    &:hover {
        background-position: 0 100% !important;
    }
}

.opui-spinner {
    position: absolute;
    top: 120px;
    left: 46%;
    opacity: 0.5;
}
</style>
